/* Kishi Kaisei : renomme la pastille de l'agent Microsoft Clarity.
   Microsoft n'expose aucun reglage pour ces libelles, on les reecrit dans le
   shadow DOM de #ads-agent-host et on les remaintient si React redessine.
   La pastille porte data-testid="entrypoint" : celle qui contient l'avatar est
   le bouton, l'autre est la suggestion tournante. Le meme emplacement alterne
   parfois entre le libelle et les suggestions, on le fige donc sur le libelle.
   Le span .sr-only porte le texte lu par les lecteurs d'ecran, on l'aligne.
   On deplace aussi la pastille en bas a gauche : centree en bas, elle masquait
   le prix sur la page panier. Microsoft n'expose aucun reglage de position.
   Si Microsoft change sa structure, le script ne trouve rien et les textes
   d'origine reviennent : aucune casse. */
(function () {
  'use strict';

  var LABEL = 'Assistant Kishi Kaisei';
  var SUGGESTION = 'Quel couteau me conseillez-vous ?';
  var ARIA = LABEL + '. Agent d’achat';

  function apply(root) {
    var pills = root.querySelectorAll('[data-testid="entrypoint"]');
    for (var i = 0; i < pills.length; i++) {
      var pill = pills[i];
      var isButton = !!pill.querySelector('.agent-avatar-bg, .agent-avatar-sparkle');
      var text = isButton ? LABEL : SUGGESTION;
      var aria = isButton ? ARIA : SUGGESTION;
      var nodes = pill.querySelectorAll('div, span');
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        if (el.children.length) continue;
        var cls = el.className ? el.className.toString() : '';
        if (cls.indexOf('min-w-0') === -1 && cls.indexOf('sr-only') === -1) continue;
        if (el.textContent !== text) el.textContent = text;
        var labelled = el.closest('[aria-label]');
        if (labelled && labelled.getAttribute('aria-label') !== aria) {
          labelled.setAttribute('aria-label', aria);
        }
      }
    }
  }

  /* Bas a gauche au lieu de centre en bas. Le conteneur est centre par
     left:50% plus un decalage de -50% de sa propre largeur. Ce decalage est
     pose par la propriete CSS translate, et non par transform : les deux sont
     independantes, donc transform:none ne l'annule pas. Sans translate:none la
     pastille repartait de 118px vers la gauche et sortait de l'ecran. On
     neutralise donc les deux. */
  function placer(root) {
    if (root.getElementById && root.getElementById('kk-agent-pos')) { return; }
    var st = document.createElement('style');
    st.id = 'kk-agent-pos';
    st.textContent =
      '[data-testid="entrypoint"]{left:1.25rem!important;right:auto!important;' +
      'transform:none!important;translate:none!important;' +
      'align-items:flex-start!important}' +
      '@media (max-width:600px){[data-testid="entrypoint"]{left:.75rem!important}}';
    root.appendChild(st);
  }

  function start(root) {
    placer(root);
    apply(root);
    new MutationObserver(function () { apply(root); }).observe(root, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  var tries = 0;
  var timer = setInterval(function () {
    var host = document.getElementById('ads-agent-host');
    if (host && host.shadowRoot) {
      clearInterval(timer);
      start(host.shadowRoot);
    } else if (++tries > 120) {
      clearInterval(timer);
    }
  }, 500);
})();
